.threeDotsLoader {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.threeDotsLoader span {
  width: 4px;
  height: 4px;
  background-color: var(
    --mantine-primary-color-filled
  ); /* Ant Design primary color */
  border-radius: 50%;
  will-change: transform, opacity;
  animation: bounce 1.4s infinite ease-in-out;
}

.threeDotsLoader span:nth-child(2) {
  animation-delay: 0.2s;
}

.threeDotsLoader span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(1);
    opacity: 0.3;
  }
  40% {
    transform: scale(1.6);
    opacity: 1;
  }
}
